const LOCALE = 'en-US';

// Returns a "short" date (e.g. "Jun 15"). Includes the year if it is not the current year
// (e.g. "Jun 15, 2025").
export const formatDate = (dateStr) => {
  const date = new Date(dateStr);

  const formatOptions = {
    day: 'numeric',
    month: 'short',
  };

  if (date.getFullYear() !== new Date().getFullYear()) {
    formatOptions.year = 'numeric';
  }

  return date.toLocaleDateString(LOCALE, formatOptions);
};
